module.exports = __webpack_public_path__ + "static/media/icon_ball.ccd25963.svg";